import React from 'react';
import { connect } from "react-redux";
import {Card, Container, Form, Message} from "semantic-ui-react";
import {BillingProductTypes, BillingTypes} from "../constants/ManualEntryRecordsActionConstants";
import Select from "react-select";
import lodash from "lodash/core";

import {
    getFormOptions,
    setBillingProductValue, setBillingTypeValue,
    setCountryValue,
    setMEBRecordsFormValues,
    setOrganizationValue,
    setTenantValue
} from "../actions/ManualEntryRecordsActions";
import * as Validation from "../../../common/utils/Validation";

let productTypeOptions = [];
const billingTypeOptions = [];

export class AddEditBillingRecordForm extends React.Component {

    constructor(props) {
        super(props);
        // initialize the billingTypeOptions from the constant in files.
        if (billingTypeOptions.length === 0) {
            for (const billingType in BillingTypes) {
                billingTypeOptions.push({
                    value: billingType,
                    label: BillingTypes[billingType]
                });
            }
        }
        // initialize the productTypeOptions from the constant in files based on the billingType
        const billingRecordObjectProductType = this.props.billingRecordObject?.billing_type;
        const billingProduct = BillingProductTypes[billingRecordObjectProductType]
        // resetting to empty array in cases where modal is re-opened in a different state
        productTypeOptions = [];
        for (const product in billingProduct) {
            productTypeOptions.push({
                value: product,
                label: billingProduct[product]
            });
        }
        // populate the form options for org/tenant/countries if it is not already loaded
        if (Object.keys(this.props.orgTenantCountryObject).length === 0) {
            this.props.populateFormOptions();
        }
    }

    handleBillingTypeSelect = ( billingType ) => {
        this.props.selectBillingType({ billingType });
        // clear the dropdown
        productTypeOptions = [];
        if (billingType !== null) {
            const currentBillingProduct = BillingProductTypes[billingType.value]
            for (const product in currentBillingProduct) {
                productTypeOptions.push({
                    value: product,
                    label: currentBillingProduct[product]
                });
            }
        }
        // clear the value for billingProduct if billingType is changed
        this.props.selectBillingProduct({ billingProduct: null })
    }

    handleBillingProductSelect = ( billingProduct ) => {
        this.props.selectBillingProduct({ billingProduct });
    }

    handleOrgSelect = ( org ) => {
        this.props.selectOrgValue({ org });
    }

    handleTenantSelect = ( tenant ) => {
        this.props.selectTenantValue({ tenant });
    }

    handleCountrySelect = ( country ) => {
        this.props.selectCountryValue({ country });
    }

    handleInputChange = (e, { name, value }) => {
        this.props.setMEBRecordsForm({ name, value });
    }

    handleBillingRecordDismiss = () => {
        Validation.clearMessages();
    }

    get formattedCountryOptions() {
        return this.props.countriesList.map(c => (
            {
                value: c.value,
                label: `${c.value} - ${c.label}`
            }
        ));
    }

    render() {

        const { billingRecordObject, organizationsList, tenantsList, countriesList,
            formMessage, formMessageHeader, formWarningNotification, formErrorNotification, formSuccessNotification,
        } = this.props;
        // this is to enable the users to select and add records for organizations with no tenants.
        let tenantsDropdownDisabled = false;
        let tenantsPlaceholderText = "Select A Tenant."

        if (tenantsList.length === 0) {
            tenantsDropdownDisabled = true;
            tenantsPlaceholderText = "No Tenants Available for Selection."
        }

        return(
            <div className={"form-page-container"}>
                <Container>
                    <Form>
                        <Card fluid>
                            <Card.Content>
                                <Form.Input
                                    required
                                    label={"Item Description"}
                                    placeholder={"Describe the billing record."}
                                    value={billingRecordObject.item_description}
                                    name="item_description"
                                    onChange={this.handleInputChange}
                                />

                                <Form.Group widths={"equal"}>
                                    <Form.Field required>
                                        <label>Billing Type</label>
                                        <Select
                                            isSearchable={true}
                                            isClearable={true}
                                            getOptionLabel={option => option.label}
                                            getOptionValue={option => option.value}
                                            options={billingTypeOptions}
                                            placeholder="Select Billing Type"
                                            value={lodash.find(billingTypeOptions, {
                                                value: billingRecordObject.billing_type
                                            })}
                                            onChange={this.handleBillingTypeSelect}
                                        />
                                    </Form.Field>
                                    <Form.Field required>
                                        <label>Billing Product</label>
                                        <Select
                                            isSearchable={true}
                                            isClearable={true}
                                            getOptionLabel={option => option.label}
                                            getOptionValue={option => option.value}
                                            options={productTypeOptions}
                                            placeholder="Select Billing Product"
                                            value={
                                                billingRecordObject.billing_product ?
                                                    lodash.find(productTypeOptions, {
                                                        value: billingRecordObject.billing_product
                                                    })
                                                    : null
                                            }
                                            onChange={this.handleBillingProductSelect}
                                        />
                                    </Form.Field>
                                    <Form.Field required>
                                        <label>Organization</label>
                                        <Select
                                            isSearchable={true}
                                            isClearable={true}
                                            getOptionLabel={option => option.label}
                                            getOptionValue={option => option.value}
                                            options={organizationsList}
                                            placeholder="Select Organization"
                                            value={
                                                billingRecordObject.organization ?
                                                    lodash.find(organizationsList, { value: billingRecordObject.organization }) :
                                                    null
                                            }
                                            onChange={this.handleOrgSelect}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                {/* Only render the tenant and country options if billing product is of the
                                following types */}
                                {billingRecordObject.billing_product === "AVS" ||
                                billingRecordObject.billing_product === "AVS_CREDIT" ||
                                billingRecordObject.billing_product === "IDV" ||
                                billingRecordObject.billing_product === "IDV_CREDIT" ||
                                billingRecordObject.billing_product === "BV" ||
                                billingRecordObject.billing_product === "BV_CREDIT"
                                    ? (
                                        <Form.Group widths={"equal"}>
                                            <Form.Field>
                                                <label>Tenant</label>
                                                <Select
                                                    isDisabled={tenantsDropdownDisabled}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    getOptionLabel={option => option.label}
                                                    getOptionValue={option => option.value}
                                                    options={tenantsList}
                                                    placeholder={tenantsPlaceholderText}
                                                    value={lodash.find(tenantsList, {
                                                        value: billingRecordObject.tenant
                                                    })}
                                                    onChange={this.handleTenantSelect}
                                                />
                                            </Form.Field>
                                            <Form.Field required={billingRecordObject.billing_type === "INVOICE" &&
                                                (billingRecordObject.billing_product === "AVS" ||
                                                    billingRecordObject.billing_product === "IDV" ||
                                                    billingRecordObject.billing_product === "BV")}>
                                                <label>Country</label>
                                                <Select
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    getOptionLabel={option => option.label}
                                                    getOptionValue={option => option.value}
                                                    options={this.formattedCountryOptions}
                                                    placeholder="Select Country"
                                                    value={lodash.find(countriesList, {
                                                        value: billingRecordObject.country_code
                                                    })}
                                                    onChange={this.handleCountrySelect}
                                                />
                                            </Form.Field>
                                        </Form.Group>
                                    )
                                    : null}

                                <Form.Group widths={"equal"}>
                                    <Form.Input
                                        required
                                        type="number"
                                        label="Item Quantity"
                                        placeholder="1000"
                                        value={billingRecordObject.item_quantity}
                                        name="item_quantity"
                                        onChange={this.handleInputChange}
                                    />
                                    <Form.Input
                                        required
                                        type="decimal"
                                        label="Item Unit Price"
                                        placeholder="1"
                                        value={billingRecordObject.item_unit_price}
                                        name="item_unit_price"
                                        onChange={this.handleInputChange}
                                    />
                                    <Form.Input
                                        disabled
                                        type="text"
                                        label="Month"
                                        placeholder=""
                                        value={billingRecordObject.month}
                                        name="month"
                                    />
                                </Form.Group>
                            </Card.Content>
                        </Card>
                    </Form>

                    {formWarningNotification || formErrorNotification || formSuccessNotification
                        ? (
                            <div style={{paddingTop: "30px"}}>
                                <Message
                                    error={formErrorNotification}
                                    warning={formWarningNotification}
                                    success={formSuccessNotification}
                                    header={formMessageHeader}
                                    list={formMessage}
                                    visible={formWarningNotification || formErrorNotification || formSuccessNotification}
                                    onDismiss={this.handleBillingRecordDismiss}
                                />
                            </div>
                        )
                        : null}
                </Container>
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    billingRecordObject: state.billing.addEditBillingRecords.billingRecordObject,
    organizationsList: state.billing.addEditBillingRecords.organizationsList,
    tenantsList: state.billing.addEditBillingRecords.tenantsList,
    countriesList: state.billing.addEditBillingRecords.countriesList,
    orgTenantCountryObject: state.billing.addEditBillingRecords.orgTenantCountryObject,

    formMessage: state.marvel.message.formMessage,
    formWarningNotification: state.marvel.message.formWarningNotification,
    formErrorNotification: state.marvel.message.formErrorNotification,
    formSuccessNotification: state.marvel.message.formSuccessNotification,
    formMessageHeader: state.marvel.message.formMessageHeader,
});

const mapDispatchToProps = dispatch => ({
    populateFormOptions: () => { dispatch(getFormOptions()) },
    setMEBRecordsForm: ({ name, value }) => { dispatch(setMEBRecordsFormValues({ name, value })) },
    selectOrgValue: ({ org }) => { dispatch(setOrganizationValue({ org })) },
    selectTenantValue: ({ tenant }) => { dispatch(setTenantValue({ tenant })) },
    selectCountryValue: ({ country }) => { dispatch(setCountryValue({ country })) },
    selectBillingProduct: ({ billingProduct }) => { dispatch(setBillingProductValue({ billingProduct })) },
    selectBillingType: ({ billingType }) => { dispatch(setBillingTypeValue({ billingType })) },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddEditBillingRecordForm)
